export default __webpack_public_path__ + "static/media/front.21f2fb36.png";